/*
 =========================================================
 * Vue Black Dashboard - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard
 * Copyright 2018 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from "vue";
import store from './store/index.js';
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";


// TIP: change to 
//import router from "./router/starterRouter"; //to start with a clean layout
//import router from "./router/index";
import router from "./router/botRouter";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
import './registerServiceWorker'

const getRuntimeConfig = async () => {
    const runtimeConfig = await fetch('runtimeConfig.json');
    return await runtimeConfig.json()
 }

getRuntimeConfig().then(function(json) {

    Vue.mixin({
        data() {
          return {
            // Distribute the runtime config into every Vue component
            runtimeConfig: json
          }
        },
      });

      Vue.use(BlackDashboard);
      Vue.use(VueRouter);
      Vue.use(RouterPrefetch);
      
      /* eslint-disable no-new */
      new Vue({
        store,
        router,
        i18n,
        render: h => h(App)
      }).$mount("#app");
});
